<aside>
          <div id="sidebar"  class="nav-collapse ">
              <!-- sidebar menu start-->
              <ul class="sidebar-menu" id="nav-accordion">
                  <li>
                      <a href="" [ngClass]="{'active': slug==''}">
                          <i class="fa fa-home"></i>
                          <span>Home</span>
                      </a>
                  </li>
                    <li class="sub-menu">
                      <a href="orders" [ngClass]="{'active': slug=='orders'}">
                          <i class="fa fa-shopping-cart"></i> 
                          <span>Orders</span>
                      </a>
                  </li>
                  <li class="sub-menu">
                      <a href="reset-password" [ngClass]="{'active': slug=='reset-password'}">
                          <i class="fa fa-lock"></i> 
                          <span>Change Password</span>
                      </a>
                  </li>
                 <!--  <li class="sub-menu">
                      <a href="javascript:;">
                          <i class="fa fa-cog"></i>
                          <span>Settings</span>
                      </a>
                      
                  </li> -->
              </ul>
              <!-- sidebar menu end-->
          </div>
      </aside>